import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TableContainer from 'Common/TableContainer';
import Select from 'react-select';
import { Loader } from '../../../Common/Loader'
// Icons
import { Pencil, Search, Trash2, Plus, CopyPlus, X, ClipboardPenLine, CloudDownload, } from 'lucide-react';
import DeleteModal from 'Common/DeleteModal';
import * as XLSX from 'xlsx';

import {
    deleteProduct as onDeleteProductList,
    getProductListByBrand,
    getProductDashboardItems,
    getProductById,
    getProductVariantInventory,

} from '../../../helpers/backend_helper';
import { ToastContainer } from 'react-toastify';
import { Common } from 'helpers/common';
import Restricted from 'permissionProvider/Restricted';
import PermissionProvider from 'permissionProvider/PermissionProvider';
import Drawer from 'Common/Components/Drawer';
import AddProduct from './AddProduct';
import LoadingPopup from 'pages/Components/LoadingPopup';
import Modal from 'Common/Components/Modal';
import UpdateInventory from './UpdateInventory';
import ExportExcel from 'pages/Components/ExportExcel';
import { AppContext } from 'context/AppContext';

const ProductList = () => {
    const [productList, setProductList] = useState<any[]>([]);
    const [excelData, setExcelData] = useState<any[]>([]);
    const [eventData, setEventData] = useState<any>();
    const [productData, setProductData] = useState<any>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showInventoryModal, setShowInventoryModal] = useState<boolean>(false);

    const [brands, setBrands] = useState<any[]>([]);
    const [selectedBrand, setSelectedBrand] = useState<any>();
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    //const [masterData, setMasterData] = useState<any>({});
    const [productVariantData, setProductVariantData] = useState<any>({});
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [dataUpdated, setDataUpdated] = useState(false);
    const [productDetails, setProductDetails] = useState('');
    const { masterData, setMasterData } = useContext(AppContext);

    const uiHelper = new Common();
    useEffect(() => {
        document.body.classList.remove('overflow-hidden');
        console.log('masterData', masterData);
        if (!masterData?.brands) {
            loadDashboardItems();
        }else{
            loadBrands(masterData.brands);
        }
    }, [])

    const loadDashboardItems = async () => {
        const response = await getProductDashboardItems();
        if (response.success) {
            console.log('dashboard items', response.data[0])
            const data = response.data[0];
            setMasterData(data);
            loadBrands(data.brands);
        }
    };

    const loadBrands = async (brandList: any[]) => {
        if (brands.length === 0) {
            if (brandList) {
                const brandItems = [{ value: '', label: 'Search by brand' }, ...brandList.map((item: any) => ({ value: item.id, label: item.name }))];
                setBrands(brandItems);
                console.log('brands', brandItems)

                const brands = [{ value: '', label: 'Select', discount: 0, hsnsac: '', gendersegment: '' }, ...brandList.map((item: any) => ({ value: item.id, label: item.name, discount: item.discount, hsnsac: item.hsnsac, gendersegment: item.gendersegment }))];
              //  setMasterData((prevState: any) => ({ ...prevState, brands: brands }));

                // If there's only one brand in the original list, auto-select it
                if (brandList.length === 1) {
                    const defaultBrand = brandItems[1]; // Index 1 because index 0 is the placeholder
                    setSelectedBrand(defaultBrand);
                    //loadProducts(defaultBrand.value);
                }
            }
        }
    };

    async function loadProducts(brandId: any) {
        try {
            setIsLoading(true)
            setProductList([]);

            let response = await getProductListByBrand(brandId);
            if (response.success) {
                console.log('prod list', response.data)
                setProductList(response.data as never[]);
            }
            setIsLoading(false)
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    }

    const loadProductData = async (prodId: any, copy: boolean = false) => {
        const prods = await getProductById(prodId);
        let prodDetail = await prods.data[0] as any;

        if (copy) {
            prodDetail = { ...prodDetail, id: null, productsProductvariants: [], productsProductimages: [] };
        }

        setProductData(prodDetail);
        return Promise.resolve(true);
    }
    useEffect(() => {
        handleExcelData();
    }, [productList]);

    // Watch for changes in selectedBrand and load products automatically
    useEffect(() => {
        if (selectedBrand && selectedBrand.value) {
            loadProducts(selectedBrand.value);
        }
    }, [selectedBrand]);

    const handleExcelData = () => {
        const newProduct = { ...productList };

        const filteredList = productList.map((product: any) => {
            const newProduct = {  } as any;

            // Initialize all possible size fields
            for (let i = 1; i <= 4; i++) {
                newProduct[`Size${i}`] = '';
                //newProduct[`Sku${i}`] = '';
                newProduct[`Inventory${i}`] = '';
            }

                       // Fill in the variant data
            product?.variants?.forEach((variant:any, index:number) => {
                const position = index + 1;
                if (position <= 4) {
                    newProduct[`Size${position}`] = variant?.size || '';
                    //newProduct[`Sku${position}`] = variant.sku;
                    newProduct[`Inventory${position}`] = variant?.inventory || '';
                }
            });

            return {
                "SKU": product?.sku,
                "Product Name": product?.productName,
                "Brand": product?.brandName,
                "Category": product?.categoryName,
                "Gender": product?.gender,
                "Unit Price": product?.unitPrice,
                "Pack Of": product?.packOf,
                "Inventory": product?.inventory,
                "Status": product?.isActive ? "Active" : "InActive",
                ...newProduct
            }
        });
        setExcelData(filteredList);
    };

    // Delete Modal
    const deleteToggle = () => setDeleteModal(!deleteModal);

    // Delete Data
    const onClickDelete = (cell: any) => {
        setDeleteModal(true);
        if (cell.productId) {
            setEventData(cell);
        }
    };

    const handleDelete = async () => {
        try {
            if (eventData) {
                console.log(eventData)

                await onDeleteProductList(eventData.productId);
                setDeleteModal(false);
                uiHelper.showSuccessMessage('Product has been deleted successfully.')
                // remove the item and then update list
                setProductList(x => x.filter((cat: any, idx) => cat.productId !== eventData.productId));
            }
        } catch (error: any) {
            console.log(error?.response?.data?.success)
            uiHelper.showErrorMessage('Product deletion failed. Please try again.')
        }
    };

    // Update Data
    const handleEditDataClick = async (ele: any) => {
        setIsLoadingData(true);

        await loadProductData(ele.productId, false);

        setIsLoadingData(false);
        setShowModal(true);
    };

    const openProductDrawer = async (prodId: any, isCopy: boolean) => {
        setIsLoadingData(true);
        if (prodId === 0) {
            setProductData(null);
        }
        else {
            await loadProductData(prodId, isCopy);
        }
        setIsLoadingData(false);
        setShowModal(true);
    }


    const openVariantPopup = async (prod: any) => {
        setIsLoadingData(true);
        setProductDetails(`${prod.productName} - (${prod.sku})`);
        const prodResponse = await getProductVariantInventory(prod.productId);
        console.log(prodResponse)
        setProductVariantData(prodResponse.data);
        setIsLoadingData(false);

        setShowInventoryModal(true);
    }

    const onInventoryUpdate = (data: any[]) => {
        console.log('onInventoryUpdate', data);
        setProductVariantData({});

        let totalInventory = 0;
        for (const item of data) {
            totalInventory += parseInt(item.inventory) || 0;
        }
        // Create a new updated product list
        const updatedProductList = productList.map((product) => {
            const updatedItem = data.find((item: any) => item.productId === product.productId);
            if (updatedItem) {
                return { ...product, inventory: totalInventory }; // Return updated product
            }
            return product; // Return unchanged product
        });

        setProductList(updatedProductList); // Update state with new array

        console.log('totalInventory', totalInventory);
        console.log('updatedProductList', updatedProductList);
        setShowInventoryModal(false);
        uiHelper.showSuccessMessage(`${totalInventory} inventory updated successfully.`);
    }

    const handleCloseDrawer = () => {
        if (dataUpdated) {
            //loadDashboardItems();
            if (selectedBrand) {
                loadProducts(selectedBrand.value);
            }
        }

        setShowModal(false);
        setProductData(null);
        setDataUpdated(false);
    }
    // columns
    const Status = ({ item }: any) => {
        switch (item) {
            case true:
                return (<span className="status px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent">Active</span>);
            case false:
                return (<span className="status px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-orange-100 border-transparent text-orange-500 dark:bg-orange-500/20 dark:border-transparent">InActive</span>);
        }
    };

    const columns = useMemo(() => [
        {
            header: "SKU",
            accessorKey: "sku",
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            header: "StyleNo",
            accessorKey: "styleNo",
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            header: "Product Name",
            accessorKey: "productName",
            enableColumnFilter: true,
            enableSorting: false,
        },
        {
            header: "Brand",
            accessorKey: "brandName",
            enableColumnFilter: true,
        },
        {
            header: "Category",
            accessorKey: "categoryName",
            enableColumnFilter: true,

        },
        {
            header: "Gender",
            accessorKey: "gender",
            enableColumnFilter: false,

        },
        {
            header: "Unit Price",
            enableColumnFilter: true,
            accessorKey: "unitPrice",
        },

        {
            header: "Pack Of",
            enableColumnFilter: false,
            accessorKey: "packOf",
        },
        {
            header: "Inventory",
            accessorKey: "inventory",
            enableColumnFilter: false,
        },
        {
            header: "Status",
            accessorKey: "isActive",
            enableColumnFilter: false,
            enableSorting: false,
            cell: (cell: any) => (
                <Status item={cell.getValue()} />
            ),
        },
        {
            header: "Action",
            enableColumnFilter: false,
            enableSorting: false,
            cell: (cell: any) => (
                <div className="flex justify-start gap-2" >
                    <button
                        title='Edit Product'
                        className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-slate-500 bg-slate-100 hover:text-white hover:bg-slate-500 dark:text-zink-200 dark:bg-zink-600 dark:hover:text-white dark:hover:bg-zink-400"
                        onClick={() => {
                            const data = cell.row.original.productId;
                            openProductDrawer(data, false);
                        }}>
                        <Pencil className="inline-block size-4 ltr:mr-1 rtl:ml-1" />
                    </button>

                    <button
                        title='Update Inventory'
                        className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-purple-500 bg-purple-100 hover:text-white hover:bg-purple-500 dark:text-zink-200 dark:bg-zink-600 dark:hover:text-white dark:hover:bg-zink-400"
                        onClick={() => {
                            const data = cell.row.original;
                            openVariantPopup(data);
                        }}>
                        <ClipboardPenLine className="inline-block size-4 ltr:mr-1 rtl:ml-1" />
                    </button>

                    <Restricted page={'products'} to='delete:' key={"subitem-" + cell.row.original.productId}>
                        <Link to="#!"
                            className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-red-500 bg-red-100 hover:text-white hover:bg-red-500 dark:bg-red-500/20 dark:hover:bg-red-500"
                            onClick={() => {
                                const orderData = cell.row.original;
                                onClickDelete(orderData);
                            }}><Trash2 className="inline-block size-4 ltr:mr-1 rtl:ml-1" />
                        </Link>
                    </Restricted>

                    <button
                        title='Copy Product'

                        className="flex items-center justify-center size-100 transition-all duration-200 ease-linear rounded-md text-custom-500 bg-custom-100 hover:text-white hover:bg-custom-500 dark:text-zink-200 dark:bg-zink-600 dark:hover:text-white dark:hover:bg-zink-400"
                        onClick={() => {
                            const data = cell.row.original.productId;
                            openProductDrawer(data, true);
                        }}>
                        <CopyPlus className="inline-block size-4 ltr:mr-2 rtl:ml-2" />
                    </button>


                </div>
            ),
        }
    ], []
    );

    const options = [
        { value: 'Select Status', label: 'Select Status' },
        { value: true, label: 'Active' },
        { value: false, label: 'inActive' },
    ];

    const handleChange = (selectedOption: any) => {
        if (selectedOption.value === 'Select Status' || selectedOption.value === 'Hidden') {
            setProductList(productList);
        } else {
            const filteredUsers = productList.filter((data: any) => data.isActive === selectedOption.value);
            setProductList(filteredUsers);
        }
    };

    const onDownloadExcelError = (errorMessage: string) => {
        uiHelper.showErrorMessage(errorMessage)
    }

    return (
        <PermissionProvider >

            <React.Fragment>
                <DeleteModal show={deleteModal} onHide={deleteToggle} onDelete={handleDelete} />
                <ToastContainer closeButton={false} limit={1} />

                <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12" style={{ marginTop: 15 }}>
                    <div className="xl:col-span-12">
                        <div className="card" id="categoriesTable">
                            {/* <div className="card-body  border-y border-dashed "> */}
                            <div className="flex items-center justify-between border-y border-dashed" style={{ padding: 10 }}>
                                <div className="flex justify-start">
                                    <h6 className="text-15 grow" style={{ marginRight: 50, marginTop: 10 }}>Product List</h6>


                                    {/* <label htmlFor="brandId" className="inline-block mb-2 text-base font-medium">Brand</label> */}
                                    <Select
                                        placeholder="Search by brand"
                                        className="border-slate-200 w-80 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                        options={brands}
                                        value={selectedBrand}
                                        isSearchable={true} // To disable search
                                        name="brandId"
                                        id="brandId"
                                        onChange={e => { setSelectedBrand(e); }}
                                    />
                                </div>
                                <div className="shrink-0">
                                    <button type="button"
                                        className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                                        onClick={() => openProductDrawer(0, false)}
                                    >
                                        <Plus className="inline-block size-4" />
                                        <span className="align-middle">Add Product</span>
                                    </button>

                                    <ExportExcel data={excelData} filename="Product List" onDownloadError={onDownloadExcelError}></ExportExcel>

                                </div>
                            </div>

                            {isLoading ? (<Loader />) :
                                (<div style={{ marginBottom: 20 }} >
                                    {productList && productList?.length > 0 ?
                                        <TableContainer
                                            isPagination={true}
                                            columns={(columns || [])}
                                            data={(productList || [])}
                                            customPageSize={20}
                                            divclassName="overflow-x-auto"
                                            tableclassName="w-full whitespace-nowrap"
                                            theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
                                            thclassName="px-3.5 py-1.0 font-semibold border-b border-slate-200 dark:border-zink-500"
                                            tdclassName="px-3.5 py-1.0 border-y border-slate-200 dark:border-zink-500"
                                            PaginationClassName="flex flex-col items-center gap-2 px-4 mt-3 md:flex-row"
                                            SearchPlaceholder='Search...'
                                            isGlobalFilter={false}
                                            isSelect={true}

                                        />
                                        :
                                        (<div className="noresult">
                                            <div className="py-6 text-center">
                                                <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                                                <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                                            </div>
                                        </div>)}
                                </div>)
                            }
                        </div>
                    </div>
                </div>

                {showInventoryModal &&
                    <Modal show={showInventoryModal} onHide={() => setShowInventoryModal(false)} id="defaultHSNSACModal" modal-center="true"
                        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
                        dialogClassName="w-screen md:w-[40rem] bg-white shadow rounded-md dark:bg-zink-600">
                        {showInventoryModal && <UpdateInventory onSave={(data) => onInventoryUpdate(data)} onHide={() => setShowInventoryModal(false)} data={productVariantData} productName={productDetails} />}
                    </Modal>
                }

                {showModal && (
                    <Drawer show={showModal} onHide={() => handleCloseDrawer()} id="cartSidePenal" drawer-end="true"
                        className="fixed inset-y-0 flex flex-col transition-transform duration-300 ease-in-out transform bg-white shadow dark:bg-zink-600 ltr:right-0 rtl:left-0 w-5/6 z-drawer">
                        <div className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500">
                            <div className="grow">
                                <h5 className="mb-0 text-16">Product
                                    {/* <span className="inline-flex items-center justify-center size-5 ml-1 text-[11px] font-medium border rounded-full text-white bg-custom-500 border-custom-500">3</span> */}
                                </h5>
                            </div>
                            <div className="shrink-0">
                                <Drawer.Header data-drawer-close="cartSidePenal" className="transition-all duration-150 ease-linear text-slate-500 hover:text-slate-800">
                                    <X className="size-4"></X>
                                </Drawer.Header>
                            </div>
                        </div>

                        <div>
                            <div className="h-[calc(100vh)] p-4 overflow-y-auto product-list">
                                <AddProduct onHide={() => setShowModal(false)}
                                    onSave={() => setDataUpdated(true)}
                                    masterData={masterData}
                                    product={productData}
                                ></AddProduct>
                            </div>
                            <div className="p-4 border-t border-slate-200 dark:border-zink-500">
                            </div>
                        </div>
                    </Drawer>
                )}
                {isLoadingData && <LoadingPopup />}
            </React.Fragment>
        </PermissionProvider>
    );
};

export default ProductList;


